import algoliasearch, { SearchIndex } from "algoliasearch";
import { useEffect, useState } from "react";

import { ArticlesBlock } from "../components/blocks/articles-block";
import { generateStorefrontImage } from "../utils/generate-storefront-image";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean => {
  return (
    __typename === "VinoData_StaticBlock" &&
    (staticType === "Recent Articles" || staticType === "Whiskymofo Articles")
  );
};

const create = (props: {
  __typename: string;
  staticType: string;
}): JSX.Element => {
  const [items, setItems] = useState<SearchResult[]>([]);
  const { staticType } = props;
  const isWhiskymofo = staticType === "Whiskymofo Articles";
  const client = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY
  );
  const index: SearchIndex = client.initIndex(
    process.env.GATSBY_ALGOLIA_ARTICLES_INDEX
  );

  interface SearchResult {
    objectID: string;
    title: string;
    description: string;
    imageUrl: string;
    slug: string;
    publishedDate: string;
    tags: [string];
  }

  const fetchItems = async (page: number) => {
    try {
      const { hits } = await index.search<SearchResult>("", {
        hitsPerPage: 5,
        page,
        filters: isWhiskymofo
          ? "isWhiskymofoArticle:True"
          : "isVinomofoArticle:True",
      });
      setItems(hits);
    } catch (error) {
      console.error("Error fetching items from Algolia:", error);
    }
  };

  const transformToArticleTilesProps = (algoliaItems: SearchResult[]) => {
    if (algoliaItems === undefined || algoliaItems.length === 0) return [];

    return algoliaItems.map((item) => ({
      id: item.objectID,
      title: item.title,
      image: generateStorefrontImage({
        url: item.imageUrl,
        width: 3000,
        height: 3000,
      }),
      link: item.slug,
      bodyText: item.description,
      tags: item.tags,
    }));
  };

  useEffect(() => {
    fetchItems(0);
  }, []);

  return (
    <ArticlesBlock
      isWhiskymofo={isWhiskymofo}
      articles={transformToArticleTilesProps(items)}
    />
  );
};

export default { test, create };
